import { atom, useAtom } from 'jotai'
import { useAtomDevtools } from 'jotai/devtools'
import type { SourcesInfo } from '../types'

export const sourcesLoadingAtom = atom<boolean>(false)
export const sourcesInfoAtom = atom<SourcesInfo>([])

export const useSourcesLoading = () => useAtom(sourcesLoadingAtom)
export const useSourcesInfo = () => useAtom(sourcesInfoAtom)

export const useAtomsDevtools = () => {
    useAtomDevtools(sourcesLoadingAtom, 'sourcesLoading')
    useAtomDevtools(sourcesInfoAtom, 'sourcesInfo')
}

export default {}
